__turbopack_context__.v({
  "container": "_08vr9q_container",
  "description": "_08vr9q_description",
  "header": "_08vr9q_header",
  "hiddenWordsText": "_08vr9q_hiddenWordsText",
  "isFullDescription": "_08vr9q_isFullDescription",
  "isInverted": "_08vr9q_isInverted",
  "selectAnotherButton": "_08vr9q_selectAnotherButton",
  "selectButton": "_08vr9q_selectButton",
  "selectedWordsTitle": "_08vr9q_selectedWordsTitle",
  "title": "_08vr9q_title",
  "type": "_08vr9q_type",
  "words": "_08vr9q_words",
});
